import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=33372895&scoped=true&"
import script from "./LanguagesList.vue?vue&type=script&lang=ts&"
export * from "./LanguagesList.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagesList.vue?vue&type=style&index=0&id=33372895&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33372895",
  null
  
)

export default component.exports